import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';
import { Case, CaseRequest } from 'app/domain/cases/case.model';

@Injectable({ providedIn: 'root' })
export class CaseApiService {
  private readonly http = inject(HttpClient);

  get(reference: string): Observable<Case> {
    return this.http.get<Case>(`${environment.apiURL}/eazi/api/customer-data/${encodeURIComponent(reference)}`);
  }

  create(caseRequest: CaseRequest): Observable<Case> {
    return this.http.post<Case>(`${environment.apiURL}/eazi/api/customer-data`, caseRequest);
  }
}
